import useStyles from './styles';
import { useHeaderState } from '@/hooks/useHeaderState';
import { HeaderLeft } from '@/sections/Header/HeaderLeft/HeaderLeft';
import { HeaderRight } from '@/sections/Header/HeaderRight/HeaderRight';

export const Header = () => {
  const classes = useStyles();
  const {
    screen,
    isAuthorized,
    viewCrop,
    viewSize,
    showBackButton,
    showGenerationsButton,
    showViewControls,
    handleBack,
    handleGenerationsClick,
    handleCloseApp,
    handleLogin,
    handleCropToggle,
    handleSizeChange,
    getMobileTitle,
  } = useHeaderState();

  return (
    <header className={classes.header}>
      <HeaderLeft
        screen={screen}
        showBackButton={showBackButton}
        mobileTitle={getMobileTitle()}
        onBack={handleBack}
      />
      <HeaderRight
        isAuthorized={isAuthorized}
        showViewControls={showViewControls}
        showGenerationsButton={showGenerationsButton}
        viewCrop={viewCrop}
        viewSize={viewSize}
        onLogin={handleLogin}
        onCropToggle={handleCropToggle}
        onSizeChange={handleSizeChange}
        onGenerationsClick={handleGenerationsClick}
        onCloseApp={handleCloseApp}
      />
    </header>
  );
};

export default Header;
